import "./styles.css";

const Privacy = () => {
  return (
    <main id="privacy">
      <div className="container">
        <h1 className="privacy-title">Política de Privacidade</h1>
        <div className="privacy-content">
          <p>
            <strong>
              Aviso de Privacidade SAV - Sistema de Antecipação de
              Vulnerabilidade
            </strong>{" "}
            <br />
            Última atualização: 01 de novembro de 2025.
          </p>
          <p>
            A SAV - Sistema de Antecipação de Vulnerabilidade é responsável pela
            proteção de dados e poderá ser contatada através do e-mail
            suporte@homosapiens.agency.
          </p>
          <p>
            <strong>1. Informações Gerais</strong> <br />A SAV - Sistema de
            Antecipação de Vulnerabilidade valoriza a privacidade de seus
            usuários e criou este Aviso de Privacidade para demonstrar seu
            compromisso em proteger os seus dados pessoais, nos termos da Lei
            Geral de Proteção de Dados nº 13.709/2018 e demais leis sobre o
            tema, bem como descrever de que forma sua privacidade é protegida
            pela SAV - Sistema de Antecipação de Vulnerabilidade ao tratar as
            suas informações pessoais. Este Aviso de Privacidade se aplica a
            todos os Usuários e potenciais clientes dos serviços oferecidos pela
            SAV - Sistema de Antecipação de Vulnerabilidade, incluindo sites,
            aplicativos ou outros meios e aponta os limites, fundamentos e
            medidas para que possa coletar, produzir, receptar, classificar,
            utilizar, acessar, reproduzir, transmitir, distribuir, processar,
            arquivar, armazenar, eliminar, avaliar ou controlar a informação,
            modificar, comunicar, transferir, difundir ou extrair os dados
            coletados, incluindo as informações de identificação pessoal, de
            acordo com as bases legais aplicáveis e todas as leis de privacidade
            e proteção de dados em vigor.
          </p>
          <p>
            <strong>2. Definições</strong> <br />
            • Dados Pessoais: é uma informação relacionada a uma pessoa natural
            identificada ou que, de alguma forma, possa identificá-la, como por
            exemplo, nome, e-mail, filiação, naturalidade, número de
            identificação pessoal ou profissional, Cadastro de Pessoa Física,
            endereço MAC dos dispositivos eletrônicos, entre outros. <br />
            • Dados Pessoais Sensíveis: são informações que se traduzem em um
            cunho discriminatório, ou seja, àqueles referentes à origem social
            ou étnica, convicção religiosa, opinião pública, filiação sindical,
            organização de caráter religioso, filosófico ou político, dado
            referente à saúde, ou à vida sexual, dado genético ou biométrico,
            quando vinculado a uma pessoa natural. <br />
            • Dados Anonimizados: é a utilização de meios técnicos razoáveis e
            disponíveis no momento do tratamento, por meio dos quais um dado
            pessoal perde a possibilidade de associação, direta ou indireta, com
            o seu titular. Nestes casos, especificamente, a Lei Geral de
            Proteção de Dados (LGPD) não será aplicada. <br />
            • Titular: é a pessoa natural a quem se referem os dados pessoais
            que são objeto de tratamento, ou seja, é aquele que detém a
            propriedade dos dados pessoais. <br />
            • Controlador: é a pessoa natural ou jurídica, de direito público ou
            privado, a quem compete as decisões referentes ao tratamento de
            dados pessoais. Isto é, o controlador é a empresa ou a pessoa que
            coordena e define como o dado pessoal será tratado, da coleta à
            eliminação. <br />
            • Operador: é a pessoa natural ou jurídica, de direito público ou
            privado, que realiza o tratamento de dados pessoais em nome do
            controlador, ou seja, é a pessoa ou a empresa que processa e trata
            os dados pessoais sob as ordens exclusivas do controlador. <br />
            • Termo de Consentimento: documento que visa registrar a
            manifestação livre, informada, inequívoca e favorável ao tratamento
            dos dados pessoais dos titulares em atendimento às finalidades
            específicas. <br />
            • Bases Legais: são as hipóteses legais inseridas na LGPD que
            autorizam o tratamento dos dados pessoais e dados pessoais
            sensíveis. <br />
            • Tratamento dos dados pessoais: engloba toda a atividade de coleta,
            produção, recepção, classificação, utilização, reutilização quando
            consentido, acesso, reprodução, transmissão, distribuição,
            processamento, arquivamento, armazenamento, eliminação, avaliação ou
            controle de informação, comunicação, transferência, difusão ou
            extração de dados de pessoas naturais. <br />
            • Princípio da Finalidade: a finalidade definirá o propósito do
            tratamento do dado pertencente ao seu titular, pela qual não poderá
            haver excesso. <br />• Princípio da Necessidade: o tratamento de
            dados pessoais deve se limitar ao mínimo necessário diante do
            propósito almejado.
          </p>
          <p>
            <strong>3. Das bases legais para o tratamento de dados</strong>{" "}
            <br />
            Cumpre-se esclarecer que todas as atividades de tratamento devem
            estar obrigatoriamente pautadas em uma das bases legais inseridas na
            Lei Geral de Proteção de Dados, descrita nos artigos 7º, dentre as
            quais se destacam algumas: <br />
            • O fornecimento do consentimento pelo titular, quando necessário
            (artigo 7º, inciso I da LGPD); <br />
            • O cumprimento de obrigação legal ou regulatória pelo Controlador
            (artigo 7º, inciso II da LGPD); <br />
            • Quando necessário para a execução de contrato ou de procedimentos
            preliminares relacionados ao contrato do qual seja parte o titular,
            a pedido do titular dos dados (artigo 7º, inciso V da LGPD); <br />
            • Para o exercício regular de direitos em processo judicial,
            administrativo ou arbitral, esse último nos termos da Lei de
            Arbitragem nº 9.307, de 23 de setembro de 1996, e artigo 7º, inciso
            VI da LGPD); <br />
            • Para a proteção da vida ou da incolumidade física do titular ou de
            terceiro (artigo 7º, inciso VII da LGPD); <br />
            • Quando necessário para atender aos interesses legítimos do
            controlador ou de terceiro, exceto no caso de prevalecerem direitos
            e liberdades fundamentais do titular que exijam a proteção dos dados
            pessoais (artigo 7º, inciso IX da LGPD); <br />• Para a proteção do
            crédito, inclusive quanto ao disposto na legislação pertinente
            (artigo 7º, inciso X da LGPD).
          </p>
          <p>
            <strong>4. Das Atividades de Tratamento de Dados</strong> <br />
            4.1 Quando a SAV - Sistema de Antecipação de Vulnerabilidade for
            Controladora:
          </p>
          <p>
            O tratamento de dados pessoais envolvendo a atividade de prestação
            de serviços se dará nas mais diversas relações em face do titular de
            dados, pelas quais, considera-se:
          </p>
          <p>
            <strong>a) Da Navegação no Website: "Agendar Demonstração"</strong>{" "}
            <br />
            A SAV - Sistema de Antecipação de Vulnerabilidade disponibiliza no
            website a possibilidade para agendar uma demonstração do Aplicativo,
            mediante a coleta dos dados pessoais: <br />
            • Nome; <br />
            • Telefone; <br />
            • E-mail; <br />
            • Cargo; <br />
            FINALIDADE: Estas informações são necessárias para fins de atender
            aos anseios do titular de dados, em regra, um usuário ainda não
            cliente, solicitando demonstração dos serviços. <br />
            BASE LEGAL: Quando necessário para procedimentos preliminares
            relacionados ao contrato do qual seja parte o titular, a pedido do
            titular dos dados (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>b) Da Navegação no Website – "Formulários Gerais"</strong>{" "}
            <br />
            Outra forma de coleta de dados através do website, se dará mediante
            o preenchimento de formulários gerais, em especial, para receber
            algum conteúdo, sendo: <br />
            • Nome/Empresa; <br />
            • E-mail; <br />
            • Cargo; <br />
            FINALIDADE: Nessa hipótese, coletamos os dados pessoais para o envio
            do conteúdo de seu interesse, inclusive, materiais e informações
            relacionados ao tema. <br />
            BASE LEGAL: Quando necessário para atender aos interesses legítimos
            do controlador (artigo 7º, inciso IX da LGPD).
          </p>
          <p>
            <strong>c) Da Navegação no Website – "Chat de Atendimento"</strong>{" "}
            <br />
            Outra forma de coleta de dados, através do website da SAV - Sistema
            de Antecipação de Vulnerabilidade se dará mediante a solicitação de
            atendimento através do atendimento via chat, sendo: <br />
            • Nome/Empresa; <br />
            • E-mail; <br />
            • Mensagem; <br />
            FINALIDADE: Estas informações são necessárias para fins de atender
            aos anseios do titular de dados, na condição de cliente ou usuário
            que solicita nossos serviços. <br />
            BASE LEGAL: Quando necessário para a execução de contrato ou de
            procedimentos preliminares relacionados ao contrato do qual seja
            parte o titular, a pedido do titular dos dados (artigo 7º, inciso V
            da LGPD).
          </p>
          <p>
            <strong>d) Da navegação no Website – "Cadastro de Usuário"</strong>{" "}
            <br />
            Outra forma de coleta de dados, através do website da SAV - Sistema
            de Antecipação de Vulnerabilidade, ocorrerá mediante o cadastro do
            usuário para utilização do Aplicativo na modalidade teste. Para
            tanto, será solicitado: <br />
            • Nome; <br />
            • E-mail; <br />
            • Telefone; <br />
            FINALIDADE: Informações necessárias para operacionalizar a
            plataforma, ainda que na modalidade teste. <br />
            BASE LEGAL: Quando necessário para a execução de contrato ou de
            procedimentos preliminares relacionados ao contrato do qual seja
            parte o titular, a pedido do titular dos dados (artigo 7º, inciso V
            da LGPD).
          </p>
          <p>
            <strong>
              e) Para a Contratação do Aplicativo SAV - Sistema de Antecipação
              de Vulnerabilidade
            </strong>{" "}
            <br />
            Já em relação às tratativas com os clientes em face do licenciamento
            do software, desde o contato inicial até a confecção do contrato, os
            dados coletados são: <br />
            • Nome Completo; <br />
            • Telefone/Celular; <br />
            • E-mail; <br />
            • Setor/Cargo; <br />
            • CPF; <br />
            • Endereço; <br />
            • Assinatura Eletrônica; <br />
            FINALIDADE: Informações necessárias para firmar um contrato entre as
            partes e prestar os serviços pactuados. <br />
            BASE LEGAL: Quando necessário para a execução de contrato (artigo
            7º, inciso V da LGPD).
          </p>
          <p>
            <strong>f) Das Relações Trabalhistas</strong> <br />
            Em se tratando do tratamento de dados envolvendo os colaboradores da
            SAV - Sistema de Antecipação de Vulnerabilidade, necessário
            esclarecer que os dados coletados serão apenas aqueles exigidos por
            Lei e necessários para que seja estabelecida de forma lícita e
            devida a relação empregatícia, a saber: <br />
            • Nome Completo; <br />
            • RG; <br />
            • CPF; <br />
            • Telefone/Celular; <br />
            • Data de Nascimento; <br />
            • Número de Inscrição no INSS; <br />
            • Sexo; <br />
            • Nacionalidade; <br />
            • Nome da Mãe; <br />
            • Nome do Pai; <br />
            • E-mail; <br />
            • Endereço Completo; <br />
            • Currículo; <br />
            • Exames Admissionais, Periódicos e Demissionais; <br />
            • Carteira de Trabalho – CTPS; <br />
            • Dados Bancários para fins de cumprimento com os encargos
            salariais; <br />
            • Certidão de Casamento; <br />
            • Certidão de Nascimento dos filhos; <br />
            FINALIDADE: Informações necessárias para efetivar o registro do
            colaborador frente aos seus direitos trabalhistas inseridos em Lei.{" "}
            <br />
            BASE LEGAL: Quando necessário para a execução de contrato (artigo
            7º, inciso V da LGPD) e para o cumprimento de obrigação legal
            (artigo 7º, inciso II da LGPD).
          </p>
          <p>
            <strong>
              4.2 Quando a SAV - Sistema de Antecipação de Vulnerabilidade for
              Operadora
            </strong>{" "}
            <br />
            Em relação ao tratamento de dados pessoais envolvendo a utilização
            do Aplicativo SAV - Sistema de Antecipação de Vulnerabilidade, em
            razão do Contrato de Licenciamento de Software, consideram-se as
            hipóteses a seguir:
          </p>
          <p>
            <strong>
              a) Para cadastro como usuário no Aplicativo SAV - Sistema de
              Antecipação de Vulnerabilidade
            </strong>{" "}
            <br />
            Para cadastro como usuário, ainda que instrutor ou médico, e
            utilização das funcionalidades, serão coletados os seguintes dados
            pessoais: <br />
            • Nome; <br />
            • E-mail; <br />
            • Telefone; <br />
            • Cargo; <br />
            • Funções; <br />
            • Registro Profissional; <br />
            • CPF; <br />
            • Navegador de Internet usado; <br />
            • Modelo do aparelho; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo. <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>
              b) Para cadastro como Trabalhador no Aplicativo SAV - Sistema de
              Antecipação de Vulnerabilidade
            </strong>{" "}
            <br />
            Para cadastro como trabalhador e utilização das funcionalidades, o
            usuário deverá fornecer os seguintes dados pessoais: <br />
            • Nome; <br />
            • CPF; <br />
            • RG; <br />
            • Sexo; <br />
            • E-mail; <br />
            • Categoria de Trabalhador; <br />
            • Matrícula; <br />
            • Data de Admissão; <br />
            • Data de Nascimento; <br />
            • Escolaridade; <br />
            • Identificação Profissional; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo. <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>c) Funcionalidade de Controle de EPI</strong> <br />
            Para utilização da funcionalidade de Controle de EPI, serão tratados
            os seguintes dados pessoais: <br />
            • Nome; <br />
            • Data de admissão; <br />
            • Assinatura do Trabalhador; <br />
            • Biometria do Trabalhador; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo. <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>d) Funcionalidade de Eleição de CIPA</strong> <br />
            Para utilização da funcionalidade de Eleição de CIPA, serão tratados
            os seguintes dados pessoais: <br />
            • Nome; <br />
            • CPF; <br />
            • Cargo; <br />
            • Data de Admissão; <br />
            • Matrícula; <br />
            • Funções; <br />
            • Fotografia do candidato; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo, em especial, para
            permitir a identificação do candidato. <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>e) Funcionalidade de Controle de Treinamento</strong> <br />
            Para utilização da funcionalidade de Controle de Treinamento, serão
            tratados os dados pessoais dos trabalhadores e dos instrutores,
            quais sejam: <br />
            • Nome; <br />
            • E-mail; <br />
            • Data de nascimento; <br />
            • Registro Profissional; <br />
            • Funções; <br />
            • Cargo; <br />
            • Assinatura/Biometria; <br />
            • Fotografia; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo, em especial, para
            permitir a emissão do certificado e criação de evidências do
            treinamento. <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>f) Funcionalidade do E-Social – CAT</strong> <br />
            Para utilização da funcionalidade do E-Social para investigação e
            comunicação de acidente de trabalho, serão tratados os dados
            pessoais dos trabalhadores e dos médicos, quais sejam: <br />
            • Nome; <br />
            • Data de nascimento; <br />
            • RG; <br />
            • CPF; <br />
            • Sexo; <br />
            • Registro Profissional; <br />
            • Cargo; <br />
            • Data de admissão; <br />
            • Assinatura/Biometria; <br />
            • Fotografia; <br />
            • Atestado Médico; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo, em especial, para
            permitir a investigação e comunicação de acidente de trabalho.{" "}
            <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>
              g) Funcionalidade do E-Social – Monitoramento da Saúde
            </strong>{" "}
            <br />
            Para utilização da funcionalidade do E-Social para monitoramento da
            saúde do colaborador, serão tratados os seguintes dados pessoais:{" "}
            <br />
            • Nome; <br />
            • Data de nascimento; <br />
            • RG; <br />
            • CPF; <br />
            • Sexo; <br />
            • Registro Profissional; <br />
            • Cargo; <br />
            • Matrícula; <br />
            • Funções; <br />
            • Exames realizados; <br />
            • Resultado dos exames; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo, em especial, para
            permitir o monitoramento da saúde do trabalhador. <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            <strong>h) Funcionalidade do E-Social – Condição Ambiental</strong>{" "}
            <br />
            Para utilização da funcionalidade de monitoramento das condições
            ambientais de trabalho, serão tratados os seguintes dados pessoais:{" "}
            <br />
            • Nome; <br />
            • CPF; <br />
            • Sexo; <br />
            • Registro Profissional; <br />
            • Cargo; <br />
            • Categoria do Trabalhador; <br />
            • Data de Admissão; <br />
            • Matrícula; <br />
            • Funções; <br />
            • Risco Ocupacional; <br />
            FINALIDADE: Informações necessárias para operacionalizar e
            disponibilizar as funcionalidades do aplicativo, em especial, para
            permitir o monitoramento da condição ambiental de trabalho. <br />
            BASE LEGAL: Quando necessário para a execução de contrato de
            licenciamento de software (artigo 7º, inciso V da LGPD).
          </p>
          <p>
            Esclarecemos aos titulares de dados que, nos casos em que a SAV -
            Sistema de Antecipação de Vulnerabilidade for Operadora de Dados,
            caberá ao cliente licenciado a atribuição da respectiva base legal
            frente ao trabalhador, instrutor e usuário, bem como o cumprimento
            do princípio da transparência, frente a eventuais coletas de
            consentimento e compartilhamento de dados com a SAV - Sistema de
            Antecipação de Vulnerabilidade.
          </p>
          <p>
            <strong>4.3 Esclarecimentos gerais</strong> <br />
            Independentemente das atividades descritas, pelas quais, inclusive,
            poderá decorrer outras não listadas, queremos esclarecer que o
            tratamento envolvendo dados pessoais e/ou pessoais sensíveis pela
            qual estamos responsáveis, será cumprido de forma a atender aos
            princípios éticos, pautados na transparência, finalidade e
            adequação, desde a coleta até a efetiva eliminação. Inclusive, na
            eventualidade de se compartilhar dados e informações pelos
            aplicativos de troca de mensagens ou mediante uma plataforma de
            integração, informamos que os dados receberão o devido tratamento em
            conformidade com a Lei Geral de Proteção de Dados.
          </p>
          <p>
            <strong>5. Compartilhamento de Dados Pessoais</strong> <br />A SAV -
            Sistema de Antecipação de Vulnerabilidade informa que, em hipótese
            alguma, os dados pessoais tratados por nós serão comercializados.
            Entretanto, poderá ser compartilhado os dados pessoais a que a SAV -
            Sistema de Antecipação de Vulnerabilidade tiver acesso, com
            prestadores de serviço necessários para disponibilizar produtos e
            prestar os serviços com qualidade, sendo que estarão sujeitos a
            obrigações contratuais na condição de Operador de Dados. É possível
            que haja o compartilhamento com outras instituições públicas e/ou
            privadas que não foram descritas, porém, sempre com respaldo a uma
            das bases legais da Lei Geral de Proteção de Dados e, na condição de
            devidos agentes de tratamentos, haverá condicionamento ao
            cumprimento a todos os princípios exigidos em lei, sobretudo, no que
            diz respeito à confidencialidade e proteção dos dados. Os dados
            pessoais tratados no Software SAV - Sistema de Antecipação de
            Vulnerabilidade são armazenados perante o Supabase, Inc.,
            localizados em São Francisco, Califórnia, nos Estados Unidos. No
            entanto, para outras atividades de tratamento fora do software, em
            razão da utilização de aplicação de terceiros poderá ocorrer a
            transferência internacional de dados, que se dará para países que
            possuem níveis adequados de proteção de dados pessoais na forma do
            art. 33, I, da Lei Geral de Proteção de Dados.
          </p>
          <p>
            <strong>6. Segurança dos Dados Pessoais</strong> <br />
            A SAV - Sistema de Antecipação de Vulnerabilidade e seus
            fornecedores utilizam vários procedimentos de segurança para
            proteger a confidencialidade, integridade e disponibilidade de seus
            dados pessoais, prevenindo a ocorrência de eventuais danos em
            virtude do tratamento desses dados. Serão utilizadas medidas
            protetivas visando a segurança das informações dos usuários e
            proteção dos bancos de dados da SAV - Sistema de Antecipação de
            Vulnerabilidade, mediante a adoção de procedimentos de segurança
            técnica e administrativa em conformidade com a legislação de dados
            vigente, entre elas: <br />
            • Os dados dos nossos usuários são armazenados em banco de dados
            seguro; <br />
            • O acesso aos dados dos usuários é limitado por meio de
            autenticação utilizando criptografia SHA-1; <br />
            • A conexão entre aplicativo, interface e servidor é feita por meio
            de conexão segura SSL; <br />
            • É mantido registro de acesso à aplicação; <br />
            • Informações sensíveis como o CPF são apresentadas parcialmente
            ocultas em todos os locais do sistema, exceto durante sua edição,
            que somente poderá ser realizada pelo usuário devidamente
            autorizado. <br />
            Convém esclarecer ainda que, para fins de utilização da biometria
            facial, não serão coletados dados pessoais que não aqueles já
            utilizados no momento do cadastro, pois mediante a captura da foto
            cria-se um template, feito com representações matemáticas, gerando
            uma grade do rosto do usuário. De todo modo, ainda que a SAV -
            Sistema de Antecipação de Vulnerabilidade adote medidas de segurança
            e monitore seu sistema para verificar vulnerabilidades e ataques
            para proteger seus dados pessoais contra divulgação não autorizada,
            acesso indevido de terceiros ou mau uso ou alteração, o usuário
            entende e concorda com a existência de riscos técnicos relacionados
            à tecnologia da informação e gerenciamento, de forma que não é
            possível garantir a inviolabilidade das informações, as quais
            poderão ser acessadas, divulgadas, alteradas ou destruídas por
            violação de qualquer uma das proteções físicas, técnicas ou
            administrativas. Caso ocorra qualquer tipo de incidente de segurança
            passível de gerar risco ou dano relevante para os usuários, eles
            serão comunicados, bem como serão notificados às autoridades
            competentes.
          </p>
          <p>
            <strong>7. Do Término do Tratamento</strong> <br />
            Estando concluídas as operações de tratamento dos dados, ou ainda,
            se não fizerem presentes as condições que exijam acesso aos dados,
            eles serão removidos de nossas bases ou anonimizados. Ainda, o
            usuário poderá solicitar à SAV - Sistema de Antecipação de
            Vulnerabilidade, por meio dos canais de comunicação elencados neste
            documento, que seja realizada a exclusão de seus dados. Entretanto,
            a SAV - Sistema de Antecipação de Vulnerabilidade poderá manter os
            dados caso seja necessário para o cumprimento de obrigações legais
            e/ou nos casos de exercício regular de direito em processo judicial,
            administrativo ou de arbitragem.
          </p>
          <p>
            <strong>8. Direitos dos Titulares de Dados</strong> <br />
            A Lei Geral de Proteção de Dados (LGPD) trouxe alguns direitos para
            os titulares, quais sejam: <br />
            • Confirmação da existência de tratamento; <br />
            • Acesso aos dados; <br />
            • Correção de dados incompletos, inexatos ou desatualizados; <br />
            • Anonimização, bloqueio ou eliminação de dados desnecessários,
            excessivos ou tratados em desconformidade com a legislação; <br />•
            Portabilidade dos dados a outro fornecedor de serviço ou produto,
            mediante requisição expressa e observados os segredos comercial e
            industrial, de acordo com a regulamentação do órgão controlador;{" "}
            <br />
            • Informação das entidades públicas e privadas com as quais o
            controlador realizou uso compartilhado de dados; <br />
            • Informação sobre a possibilidade de não fornecer o consentimento e
            sobre as consequências negativas advindas; <br />
            • Revogação do consentimento; <br />
            • Reclamação à Autoridade Nacional de Proteção de Dados; <br />
            • Oposição ao tratamento, se irregular; <br />
            • Eliminação dos dados pessoais tratados com o consentimento do
            titular, exceto no caso de cumprimento de obrigação legal ou
            regulatória pelo controlador. Neste caso, o tratamento dos dados
            pessoais será mantido com o objetivo específico de atender a estas
            obrigações. <br />
            Independentemente do direito a ser exercido pelo titular, é
            disponibilizado no website da SAV - Sistema de Antecipação de
            Vulnerabilidade, de forma facilitada, um formulário específico, para
            o atendimento a um dos seus direitos inseridos na Lei. Caso prefira,
            o titular pode fazer as solicitações entrando em contato com o
            Encarregado de Proteção de Dados por meio do e-mail
            dpo@onsafety.com.br e estes pedidos serão considerados de acordo com
            as leis aplicáveis.
          </p>
          <p>
            <strong>9. Revisões à Política</strong> <br />
            Esta política é válida a partir de sua publicação. Sempre que houver
            modificação nos presentes termos, os usuários serão notificados
            através dos endereços de e-mail cadastrados, por meio de notificação
            no aplicativo, bem como os termos estarão sempre visíveis e de fácil
            acesso nas plataformas SAV - Sistema de Antecipação de
            Vulnerabilidade. Caso o usuário tenha quaisquer dúvidas a respeito
            das políticas de privacidade do website ou aplicativo ou sobre os
            dados pessoais que tratamos, entre em contato com a SAV - Sistema de
            Antecipação de Vulnerabilidade, por meio dos canais de atendimento.
          </p>
          <p>
            <strong>10. Foro de Eleição e Legislação Aplicável</strong> <br />A
            presente política de privacidade foi desenvolvida em conformidade
            com a Lei Geral de Proteção de Dados nº 13.709/2018 e, caso haja
            qualquer conflito decorrente da sua aplicabilidade, o foro
            competente para dirimir o conflito será o da Comarca de São Paulo,
            no estado de São Paulo.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Privacy;
